import styled, { css } from 'styled-components'
import { irem, rem } from '../../../utils'
import { StyledFlexibleContentRow } from '../flexibleContentRow'
import { StyledAccordionPanel } from '../../accordion/accordion'
import { StyledFcpDisclaimerBlock } from '../flexibleTableStyles'
import { StyledLinksItem } from '../../linkgrid/StyledLinkGrid'
import { StyledFeaturesListItemWrapper } from '../../FeaturesList/styledFeaturesList'
import { StyledLinkTitle } from '../../CardDesignCarousel/styledCardDesignCarousel'
import { StyledTableRightContainer } from '../../feesBenefitsTable/styledFeesBenefitsTable'
import { StyledWrapper } from './fullScreenCta'

const getBgColor = (colour?: string) => {
  if (!colour) {
    return '#fff'
  }

  switch (colour) {
  case 'grey':
    return '#EAE9E4'
  case 'lightgrey':
    return '#f2f2f2'
  case 'orange':
    return '#FEF0ED'
  case 'gradient':
    return 'linear-gradient(180deg, #FFF 0%, var(--Light-Grey, #F2F2F2) 100%)'
  default:
    return '#fff'
  }
}

export const AltBg = styled.div<{ colour?: string; $preGradient?: boolean; $postGradient?: boolean }>`
  background-color: ${props => getBgColor(props.colour)};
  position: relative;
  margin: ${props => rem(props.$preGradient ? 0 : 50)} 0 ${props => rem(props.$postGradient ? 0 : 50, props.theme)};
  padding: ${rem(70)} 0;
    
  --alt-bg-color: ${props => getBgColor(props.colour)};

  > * + * > ${StyledFlexibleContentRow} {
    margin-block-start: ${props => props.theme.custom.spacing.paragraph};
  }

  &:first-child {
    margin-block-start: 0;
  }

  &:last-child {
    margin-block-end: 0;
  }
    
  &::before, &::after {
    position: absolute;
    display: none;
    content: "";
    height: ${rem(500)};
    width: 100%;
    z-index: -1;
  }
    
  &::before {
    top: 0;
    transform: translateY(-100%);
    background: linear-gradient(to bottom, transparent, ${props => getBgColor(props.colour)});
      
    ${props => props.$preGradient && css`
      display: block;
    `}
  }

  &::after {
    top: 100%;
    background: linear-gradient(to top, transparent, ${props => getBgColor(props.colour)});

    ${props => props.$postGradient && css`
      display: block;
    `}
  }

  ${StyledTableRightContainer},
  ${StyledFeaturesListItemWrapper},
  ${StyledLinkTitle}::after,
  ${StyledFcpDisclaimerBlock},
  ${StyledAccordionPanel},
  ${StyledLinksItem},
  ${StyledLinkTitle},
  blockquote {
    background-color: white;
  }

  ${StyledFcpDisclaimerBlock}> div:first-child {
    padding-top: ${rem(16)};
    background-color: ${props => props.colour !== 'orange' ? '#F2F2F2' : '#FEF0ED'} !important;
  }

  ${props => props.theme.breakpoints.up('md')} {
    margin: ${props => rem(props.$preGradient ? 0 : 120)} 0 ${props => rem(props.$postGradient ? 0 : 120, props.theme)};
  }


    // If the next section is a full screen cta, offset the margin
    + * > ${StyledWrapper}:first-child {
        margin-block-start: ${irem(-50)};
        
        ${props => props.theme.breakpoints.up('md')} {
            margin-block-start: ${irem(-120)};
        }
    }
    
    // If the previous section is a full screen cta, offset the margin
    div:has(${StyledWrapper}) + & {
        margin-block-start: ${irem(-50)};

        ${props => props.theme.breakpoints.up('md')} {
            margin-block-start: ${irem(-120)};
        }
    }
    
    & + & {
        margin-block-start: ${irem(-50)};
        
        ${props => props.theme.breakpoints.up('md')} {
            margin-block-start: ${irem(-120)};
        }
    }
`